<script>
import { ref, computed, onMounted } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import LandingOffer from './LandingOffer';
import LandingInfo from './LandingInfo';
import LandingCard from './LandingCard';
import LandingFooter from './LandingFooter.vue';
import InputText from './InputText.vue';
import Recaptcha from '../../common/components/Recaptcha.vue';
import $ from 'jquery';

export default {
  name: 'PageLandingFioul',
  components: {
    LandingOffer,
    LandingInfo,
    LandingCard,
    LandingFooter,
    InputText,
    Recaptcha,
  },
  props: {
    optin: {
      type: String,
      default: '',
    },
    hasmezzo: {
      type: String,
      default: '0',
    },
  },
  setup(props) {
    const recaptcha = ref(null)
    const cards = ref([
      { title: 'Remplacement chaudière fioul...', text: 'Le gaz émet moins de CO2...', img: 'chaudiere_draw' },
      { title: '0€ à l’installation de la citerne', sup: '(4)', text: 'Vous ne payez rien...', img: 'tool' },
      { title: '10 mensualités fixes', sup: '(4)', text: 'Vous payez uniquement...', img: 'calendar' },
      { title: 'Un prix garanti 3 ans', sup: '(4)', text: 'Plus besoin de vous inquiéter...', img: 'lock' },
      { title: 'Un contrat à durée de 3 ans', sup: '(4)', text: 'C’est vous qui décidez...', img: 'docs' },
      { title: 'Retrait de la cuve fioul', sup: '(2)', text: 'Un accompagnement pourra être apporté...', img: 'removal_fioul' },
    ]);

    const isPosted = ref(false);
    const captchaError = ref(false);
    const formEl = ref(null);
    const form = ref({
      lastname: '',
      firstname: '',
      zipcode: '',
      phone: '',
      email: '',
      acceptance: '',
      captcha: '',
      mention: '',
      specify_your_request: '',
      mezzo: props.hasmezzo,
    });


    const { values, errors, defineField, validate } = useForm({
          validationSchema: yup.object({
            lastname: yup.string().required('Le nom est requis'),
            firstname: yup.string().required('Le prénom est requis'),
            type: yup.string().required('Le type est requis'),
            zipcode: yup.number().required('Le code postal est requis'),
            companyname: yup.string().required('Le nom de la companie est requis'),
            email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
              }),
            phone: yup
              .string()
              .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide'),
        });

    const [type, typenameAttrs] = defineField('type', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [lastname, lastnameAttrs] = defineField('lastname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [firstname, firstnameAttrs] = defineField('firstname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [email, emailAttrs] = defineField('email', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [phone, phoneAttrs] = defineField('phone', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [zipcode, zipcodeAttrs] = defineField('zipcode', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const showForm = computed(() => !isPosted.value);
    const showConfirmation = computed(() => isPosted.value);

    onMounted(() => {
      formEl.value = document.querySelector('form');
      isPosted.value = formEl.value?.querySelector('.webform-confirmation') !== null;
      $(document).ready(() => {
        window.dataLayer = window.dataLayer || [];
        let itemToPush = {};
        let H1 = $('h1');
        if (H1.length) {
          itemToPush['pagename'] = H1.text().replace(/["+?!]/g, '').replace(/[#_', ]/g, '_').normalize('NFD').replace(/[̀-ͯ]/g, '');
        }
        itemToPush['pagetype'] = 'Landing page';
        itemToPush['event'] = 'page_load';
        window.dataLayer.push(itemToPush);
      });
    });

    const updateDatalayer = (formData) => {
      formData.form_name = formData.form_name.trim().replace(/["+?!]/g, '').replace(/[#_', ]/g, '_').normalize('NFD').replace(/[̀-ͯ]/g, '');
      window.dataLayer.push(formData);
    };

    const scrollToForm = () => {
      document.getElementById('form')?.scrollIntoView();
    };

    const onCaptchaExpired = () => {
      recaptcha.value.reset();
      captchaError.value = true;
    };

    const onCaptchaVerified = (token) => {
      recaptch.value.reset();
      form.value.captcha = token;
      submitForm();
    };

    const checkRecaptcha = () => {
      captchaError.value = false;
      recaptcha.value.execute();
    };

    const submitForm = () => {
      if (form.value.captcha.length > 0) {
        sendForm();
      }
    };

    const sendForm = () => {

      form.lastname = lastname
      form.firstname = firstname
      form.type = type
      form.phone = phone
      form.email = email
      form.zipcode = zipcode

      const formData = {
        event: 'form_confirmation',
        form_type: 'Landing_Fioul',
        form_name: document.querySelector('h1.title.title--1')?.textContent || '',
      };

      Object.entries(form.value).forEach(([key, value]) => {
        let input = formEl.value?.querySelector(`[name='${key.toLowerCase()}']`);
        if (input) {
          input.value = key === 'mention' ? (value ? props.optin : '') : key === 'acceptance' ? 'Envoyer mon email' : value;
        }
      });
      updateDatalayer(formData);
      formEl.value?.submit();
    };

    return {
      cards,
      isPosted,
      captchaError,
      form,
      formEl,
      showForm,
      showConfirmation,
      updateDatalayer,
      scrollToForm,
      onCaptchaExpired,
      onCaptchaVerified,
      checkRecaptcha,
      recaptcha,
      submitForm,
      sendForm,
      type,
      firstname,
      lastname,
      email,
      phone,
      errors,
      values,
      zipcode
    };
  },
};
</script>

<style scoped lang="sass">
@import ../../common/styles/mixins
@import settings
@import typography
@import PageLandingFioul
@import LandingForm
</style>
